function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M18.889 3.222h-1.111v-1.11c0-.612-.5-1.112-1.111-1.112H1.11C.5 1 0 1.5 0 2.111v13.333c0 .612.5 1.112 1.111 1.112h1.111v1.11c0 .612.5 1.112 1.111 1.112H18.89c.611 0 1.111-.5 1.111-1.111V4.333c0-.61-.5-1.11-1.111-1.11zM2.222 4.333v11.111H1.113l-.002-.002V2.112l.002-.001h15.552s.002 0 .002.002v1.109H3.334c-.611 0-1.111.5-1.111 1.11v.001zM18.89 17.664l-.002.003H3.335s-.002-.001-.002-.003V4.335s0-.002.002-.002h15.552l.002.002v13.33z"
}), React.createElement("path", {
  d: "M16.667 7.111a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0z"
}), React.createElement("path", {
  d: "M17.778 16.556H4.444v-2.223l3.89-6.666 4.444 5.555h1.11l3.89-3.333z"
}));

var SvgIconSingleEdit = function SvgIconSingleEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSingleEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-single-edit.ef5b25d8.svg";
export { ForwardRef as ReactComponent };